/**
 * Public contact targets for landing CTAs (mailto). No backend API.
 * Prefer REACT_APP_SUPPORT_EMAIL when set; safe fallback avoids throwing during prerender/build.
 */
/** Shown in About, legal modals, and JSON-LD unless overridden by env-specific flows. */
export const PUBLIC_CONTACT_EMAIL = 'founder@tranzit.io' as const;

const DEMO_SUBJECT = 'Book a demo — Tranzit';

export function getLandingBookDemoMailto(): string {
  const email = process.env.REACT_APP_SUPPORT_EMAIL?.trim();
  if (email) {
    return `mailto:${email}?subject=${encodeURIComponent(DEMO_SUBJECT)}`;
  }
  return `mailto:${PUBLIC_CONTACT_EMAIL}?subject=${encodeURIComponent(DEMO_SUBJECT)}`;
}
